// Mock data for The WillisTRAINING Method website

export const mockServices = [
  {
    id: 1,
    title: 'Performance Mindset Coaching',
    description: 'Build mental resilience and discipline to achieve lasting results through structured mindset training.',
    icon: 'Brain'
  },
  {
    id: 2,
    title: '1-on-1 & Group Fitness Training',
    description: 'Personalized training programs designed to build strength, improve mobility, and boost confidence.',
    icon: 'Dumbbell'
  },
  {
    id: 3,
    title: 'Kids Sports & Athletic Development',
    description: 'Youth training programs that develop athletic skills, confidence, and a strong foundation for lifelong fitness.',
    icon: 'Users'
  },
  {
    id: 4,
    title: 'Nutrition Guidance',
    description: 'Evidence-based nutrition support to fuel your performance and support your training goals.',
    icon: 'Apple'
  },
  {
    id: 5,
    title: 'Gym Buddy',
    description: 'In-gym support to help you feel confident, learn the machines, and train with purpose — no intimidation, no guesswork.',
    icon: 'UserCheck'
  },
  {
    id: 6,
    title: 'Remote Coaching',
    description: 'Get expert coaching and accountability from anywhere with virtual training sessions and personalized programming.',
    icon: 'Video'
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    role: 'Marketing Manager',
    text: 'Working with Willis completely changed my approach to fitness. It\'s not just about the workouts — the mindset coaching helped me stay consistent for the first time in years.',
    rating: 5
  },
  {
    id: 2,
    name: 'David Chen',
    role: 'Software Engineer',
    text: 'I came in feeling weak and unmotivated. Six months later, I\'m stronger, more confident, and actually excited to train. The structured approach makes all the difference.',
    rating: 5
  },
  {
    id: 3,
    name: 'Jessica Park',
    role: 'Parent of Youth Athlete',
    text: 'My son\'s athletic performance has improved dramatically. More importantly, his confidence and discipline have grown in ways that impact every area of his life.',
    rating: 5
  }
];

export const mockContactSubmissions = [];

// Function to save contact form submission to localStorage
export const saveContactSubmission = (formData) => {
  const submissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
  const newSubmission = {
    ...formData,
    id: Date.now(),
    submittedAt: new Date().toISOString()
  };
  submissions.push(newSubmission);
  localStorage.setItem('contactSubmissions', JSON.stringify(submissions));
  return newSubmission;
};

// Function to get all contact submissions
export const getContactSubmissions = () => {
  return JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
};